export function useToast() {
  const { $toast } = useNuxtApp() as any;

  // 创建可直接调用的函数
  const toast = (message: string, duration?: number) => {
    $toast.show(message, duration);
  };

  // 复制 $toast 的所有方法到 toast 函数上
  Object.assign(toast, $toast);

  return toast;
}

export default useToast;
